import { TypographyStyleOptions } from '@material-ui/core/styles/createTypography'

interface FontStyle {
    [key: string]: TypographyStyleOptions
}

const fontStyles: FontStyle = {
    Title: {
        fontFamily: 'GothamNarrow-Book',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '3rem',
        lineHeight: 1.2,
    },
    Title2: {
        fontFamily: 'GothamNarrow-Book',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '2rem',
        lineHeight: 1.2,
    },
    Title3: {
        fontFamily: 'GothamNarrow-Book',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '1.5rem',
        lineHeight: 1.2,
    },
    Subtitle: {
        fontFamily: 'GothamNarrow-Book',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '1.25rem',
        lineHeight: 1.2,
    },
    NormalText: {
        fontFamily: 'GothamNarrow-Book',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '1rem',
        lineHeight: 1.5,
    },
    SmallText: {
        fontFamily: 'GothamNarrow-Book',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '0.75rem',
        lineHeight: 0.85,
    },
    ButtonText: {
        fontFamily: 'GothamNarrow-Book',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '1rem',
        lineHeight: 1.2,
    },
}

export default fontStyles
